
import { gql } from 'apollo-boost';

export const NOTIFICATIONS_BY_STATUS = gql`
    query notificationsByStatus($status: Int!) {
        notificationsByStatus(status: $status) {
            id
            title
            fileUrl
            message
        }
    }
`

export const GET_STUDENT_READING_LOGS_TARGET = gql`
query currentStudent($weekStart: String!) {
    currentStudent {
        id
        studentWeeklyTarget {
            id
            parentLogsTarget
            studentId
            studentLogsTarget
            teacherLogsTarget
        }
        weeklyStudentReportData(weekStart: $weekStart) {
            id
            parentLogsCount
            parentLogsTarget
            studentLogsCount
            studentLogsTarget
            teacherLogsCount
            teacherLogsTarget
            weekStart
        }
    }
}
`;